/* MLD · Spedizioni: alert soglia gratuita, peso variante in PDP, popup tariffe.
   Caricare in theme.liquid con defer:
   <script src="{{ 'mld-spedizioni.js' | asset_url }}" defer></script> */
(function () {
  'use strict';

  var fmtEur = function (n) {
    return n.toFixed(2).replace('.', ',');
  };
  var fmtKg = function (grams) {
    return (grams / 1000).toFixed(grams % 1000 === 0 ? 0 : 1).replace('.', ',');
  };

  /* ---------- Popup ---------- */
  var popup = document.getElementById('MldShipPopup');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mld-ship-open]')) {
      e.preventDefault();
      if (popup) popup.hidden = false;
    }
    if (e.target.closest('[data-mld-ship-close]') || e.target === popup) {
      if (popup) popup.hidden = true;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup) popup.hidden = true;
  });

  document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href="#spedizioni"]');
  if (!link) return;
  e.preventDefault();
  const popup = document.getElementById('MldShipPopup');
  if (popup) popup.hidden = false;
});

  /* ---------- Alert carrello ---------- */
  function renderAlert(wrap, cart) {
    var zone = wrap.dataset.zone;
    var cfgAll;
    try { cfgAll = JSON.parse(wrap.dataset.config); } catch (err) { return; }
    var cfg = cfgAll[zone];
    var box = wrap.querySelector('[data-mld-ship-alert-box]');
    var txt = wrap.querySelector('[data-mld-ship-alert-text]');
    var bar = wrap.querySelector('[data-mld-ship-bar]');
    var meta = wrap.querySelector('[data-mld-ship-meta]');

    /* Zone estere o carrello vuoto: nessun alert */
    if (!cfg || !cart || cart.item_count === 0) {
      box.hidden = true; bar.hidden = true; meta.hidden = true;
      return;
    }

    var sub = cart.total_price / 100;           /* B2B: prezzi IVA esclusa */
    var kg = cart.total_weight / 1000;
    var missing = cfg.threshold - sub;
    var overCap = cfg.cap !== null && kg > cfg.cap;
    var kgLabel = cfg.cap !== null
      ? 'peso ' + fmtKg(cart.total_weight) + ' / ' + cfg.cap + ' kg'
      : 'peso ' + fmtKg(cart.total_weight) + ' kg';

    box.hidden = false; bar.hidden = false; meta.hidden = false;
    box.classList.remove('is-ok', 'is-over');
    bar.classList.remove('is-over');

    if (overCap) {
      box.classList.add('is-over');
      bar.classList.add('is-over');
      txt.textContent = '⚠️ Hai superato i ' + cfg.cap + ' kg: la spedizione gratuita non è disponibile, si applica la tariffa di € ' + cfg.fee + '.';
      bar.querySelector('i').style.width = '100%';
    } else if (missing > 0) {
      txt.textContent = '🚚 Ti mancano € ' + fmtEur(missing) + ' per la spedizione gratuita.';
      bar.querySelector('i').style.width = Math.min(100, (sub / cfg.threshold) * 100) + '%';
    } else {
      box.classList.add('is-ok');
      txt.textContent = '✅ Spedizione gratuita ottenuta!';
      bar.querySelector('i').style.width = '100%';
    }
    meta.querySelector('[data-mld-ship-meta-sub]').textContent =
      'Subtotale € ' + fmtEur(sub) + ' / ' + cfg.threshold + ' €';
    meta.querySelector('[data-mld-ship-meta-weight]').textContent = kgLabel;
  }

  function refresh() {
    var wraps = document.querySelectorAll('[data-mld-ship-alert]');
    if (!wraps.length) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        wraps.forEach(function (w) { renderAlert(w, cart); });
      })
      .catch(function () {});
  }
  window.MLDShip = { refresh: refresh };

  /* Aggiornamento: eventi comuni dei temi + intercettazione fetch add/change */
  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 150); });
    }
    return p;
  };

  /* ---------- Peso variante in PDP ---------- */
  function updateWeight(variantId) {
    document.querySelectorAll('[data-mld-weight]').forEach(function (el) {
      var map = {};
      el.dataset.weights.split(',').forEach(function (pair) {
        var kv = pair.split(':');
        map[kv[0]] = parseInt(kv[1], 10);
      });
      var g = map[variantId];
      if (g !== undefined) {
        el.querySelector('[data-mld-weight-value]').textContent = fmtKg(g) + ' kg';
      }
    });
  }
  /* Variante cambiata: i temi aggiornano ?variant= nell'URL o emettono un evento */
  document.addEventListener('change', function (e) {
    if (!e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, .product-form')) return;
    setTimeout(function () {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (id) updateWeight(id);
    }, 100);
  });
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) updateWeight(String(e.detail.variant.id));
  });

  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();
})();